import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Config } from "./config";
import { tap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private configUrl: string = "/assets/config.json";
  private config: Config = null;

  constructor(private http: HttpClient) {}

  private loadConfig(): Observable<Config> {
    return this.http
      .get<Config>(this.configUrl)
      .pipe(tap(config => (this.config = config)));
  }

  public getConfig(): Observable<Config> {
    return this.config != null ? of(this.config) : this.loadConfig();
  }
}
